module.exports = __webpack_public_path__ + "img/banner_xwzx@2x.8af86102.png";